"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessage = void 0;
const react_1 = __importDefault(require("react"));
const ChatMessage = ({ message, userLabel = 'You', assistantLabel = 'AI', assistantIcon, renderContent, }) => {
    const isUser = message.role === 'user';
    return (react_1.default.createElement("div", { className: `cw-chat-message ${isUser ? 'cw-chat-message-user' : 'cw-chat-message-assistant'}` },
        !isUser && (react_1.default.createElement("div", { className: "cw-chat-message-avatar" }, assistantIcon || assistantLabel)),
        react_1.default.createElement("div", { className: "cw-chat-message-content" }, renderContent ? renderContent(message.content) : message.content),
        isUser && (react_1.default.createElement("div", { className: "cw-chat-message-avatar cw-chat-message-avatar-user" }, userLabel))));
};
exports.ChatMessage = ChatMessage;
